<div lazy-load-images>
  <router-outlet></router-outlet>
  <div *appShellNoSSR class="search" [ngClass]="{'expand': gameSearch?.showPopup}">
    @if (gameSearch?.showPopup) {
      <app-search-popup></app-search-popup>
    }
  </div>
</div>

@if (translations.loading) {
  <div class="language-preloader">
    <div class="language-preloader__bar"></div>
  </div>
}

@defer (when installApp.showInstallAppAfterDepositBanner && !installApp.isNativeApp && !installApp.hideInstallAppByCMS) {
  <app-install-app-banner></app-install-app-banner>
}

<app-toast-message *appShellNoSSR></app-toast-message>
<app-game-iframe *appShellNoSSR></app-game-iframe>

<app-to-top></app-to-top>
